import type { AxiosInstance } from 'axios';
import authService from './auth.service';
import type {
  AlertDisposition,
  AlertScope,
  MonitoringAlert,
} from '../types/monitoring';

class MonitoringService {
  private get api(): AxiosInstance {
    return authService.getApi();
  }

  /** Transaction-monitoring alerts. Defaults to the OPEN queue — the work list;
   *  `closed` / `all` retrieve adjudicated ones for the record. */
  async listAlerts(scope: AlertScope = 'open'): Promise<MonitoringAlert[]> {
    const res = await this.api.get<MonitoringAlert[]>(
      '/api/v1/compliance/monitoring/alerts',
      { params: { scope } },
    );
    return res.data;
  }

  /** Record a maker/checker decision. `dismissed` needs a prior
   *  `proposed_dismissal` by a DIFFERENT reviewer (the API enforces it). */
  async disposition(
    alertId: number,
    disposition: AlertDisposition,
    reason: string,
  ): Promise<{ id: number; disposition: AlertDisposition; alert_closed: boolean }> {
    const res = await this.api.post<{
      id: number;
      disposition: AlertDisposition;
      alert_closed: boolean;
    }>(`/api/v1/compliance/monitoring/alerts/${alertId}/dispositions`, {
      disposition,
      reason,
    });
    return res.data;
  }

  async openCount(): Promise<number> {
    return (await this.listAlerts('open')).length;
  }
}

export default new MonitoringService();
